/** * @author SwathiDivya Bhavaraju * @email swathidivya.bhavaraju@ul.com * @create date 2020-05-15
16:12:03 * @modify date 2020-05-15 16:12:03 * @desc [description] */
<template>
  <div class="content-wrappper">
    <div class="row account-container">
      <div class="row">
        <div class="col-xs-12">
          <router-link class="sub-heading" to="/layout/launchpad">
            <i class="fa fa-angle-left"></i>Active Accounts List
          </router-link>
        </div>
      </div>
      <div class="row mt-25">
        <div class="search-container col-md-7 col-sm-6">
          <div class="search-input" style="position: relative">
            <search-box v-model="accountSearch"></search-box>
          </div>
        </div>
      </div>
      <div class="row mt-25">
        <div class="col-xs-12 col-md-10">
          <table class="table" v-if="accountsList">
            <thead>
              <tr>
                <th @click="sortBy('account_name')" :class="{ active: sortKey === 'account_name' }">
                  Account Name
                  <span class="arrow" :class="sortOrder !== 'asc' ? 'dsc' : 'asc'"></span>
                </th>
                <th>Account ID</th>
                <th>Expiry Date</th>
              </tr>
            </thead>
            <tbody v-if="accountsList && accountsList.length">
              <tr v-for="(account, index) in orderedList" :key="index">
                <td
                  class="account_name cursor-pointer decoration-underline"
                  @click="openAccountDetails(account.account_id)"
                >
                  {{ account.account_name }}
                </td>
                <td class="account_id">{{ account.account_id }}</td>
                <td class="account_expiry">{{ account.expiry_date | date('DD-MM-YYYY') }}</td>
              </tr>
            </tbody>
          </table>
          <h2 class="center" v-if="accountsList && !accountsList.length">No Account(s) found</h2>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import Loader from '../UIComponents/Loader.vue';
import SearchBox from '../UIComponents/SearchBox.vue';
// import SearchBox from '../../UIComponents/SearchBox.vue';
import { getActiveSBAccountsList } from '../../apis/submissionBuilder';

export default {
  data() {
    return {
      loaderStatus: false,
      accountsList: [],
      accountSearch: '',
      sortKey: 'account_name',
      sortOrder: 'asc'
    };
  },
  components: {
    Loader,
    SearchBox
  },
  methods: {
    openAccountDetails(accountId) {
      sessionStorage.setItem('getPreviousUrl', window.location.pathname);
      sessionStorage.setItem('getAccountDetailsId', accountId);
      this.$router.push('/layout/accountdetails');
    },
    sortBy(sortKey) {
      this.sortOrder = this.sortOrder !== 'asc' ? 'asc' : 'desc';
      this.sortKey = sortKey;
    },
    resetSearch() {
      this.accountSearch = '';
    }
  },
  computed: {
    orderedList() {
      let filteraccountsList = [];
      if (this.accountSearch) {
        filteraccountsList = this.accountsList.filter((row) =>
          Object.keys(row).some(
            (key) => String(row[key]).toLowerCase().indexOf(this.accountSearch.toLowerCase()) > -1
          )
        );
      } else {
        filteraccountsList = this.accountsList;
      }
      return _.orderBy(
        filteraccountsList,
        (each) => each[this.sortKey].toLowerCase(),
        this.sortOrder
      );
    }
  },
  async created() {
    this.loaderStatus = true;
    this.accountsList = await getActiveSBAccountsList();
    this.filteraccountsList = this.accountsList;
    this.loaderStatus = false;
  },
  filters: {
    date(value, format) {
      return moment(value).format(format);
    }
  }
};
</script>
<style scoped>
.account-container {
  margin: 25px;
}
.sub-heading > i {
  margin-right: 6px;
}
.sub-heading {
  font-family: Roboto;
  font-style: normal;
  font-size: 18px;
  color: #0b3c61;
  cursor: pointer;
}
.account-container .table > tbody > tr > td {
  padding: 10px !important;
  border-bottom: 1px solid #ebeef5 !important;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}
.account-container .table > thead > tr > th {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  padding: 10px;
  color: #0b3c61;
  border-bottom: 1px dashed #ebeef5 !important;
}
.account-container .table > thead,
.account-container .table > thead .active {
  background-color: #fff;
}
.account-container .table .account_name {
  width: 60%;
}
.account-container .table .account_id {
  width: 20%;
}
.account-container .table .account_expiry {
  width: 20%;
}
.mt-25 {
  margin-top: 25px;
}
.search-input input:hover {
  box-shadow: none;
  border-color: #96c8da;
}
@media screen and (max-width: 767px) {
  .account-container .table .account_name {
    width: 40%;
  }
  .account-container .table .account_id {
    width: 25%;
  }
  .account-container .table .account_expiry {
    width: 25%;
  }
}
</style>
